var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import moment from 'moment';
import Calculator from '../Calculator';
import PricesView from '../PricesView';
import { T } from '../../helpers/i18n';
import { FieldType } from '../../elements';
import { rules } from '../../helpers/Validation';
import { inject } from 'mobx-react';
import { InvertWeekDays, isSomeWeekdaySelected } from './Utils';
import cloneDeep from 'lodash/cloneDeep';
var ModalConfigPrice = inject('store')(function (props) {
    var store = props.store, modalVisible = props.modalVisible, selectedDay = props.selectedDay, stretch = props.stretch, money = props.money, passengerCategories = props.passengerCategories, from = props.from, to = props.to, weekDaySelected = props.weekDaySelected, busy = props.busy, onCancelClick = props.onCancelClick, resetState = props.resetState, onSavePriceClick = props.onSavePriceClick, onFromClick = props.onFromClick, onToClick = props.onToClick, onClearClick = props.onClearClick;
    // estado para tab activo
    var _a = useState('1'), activeTab = _a[0], setActiveTab = _a[1];
    // estado para precios por fecha
    var _b = useState([]), prices = _b[0], setPrices = _b[1];
    var _c = useState([]), originalPrices = _c[0], setOriginalPrices = _c[1];
    useEffect(function () {
        if (from && to) {
            props.store.datePricesStore.readRange(moment(from).format('YYYY-MM-DD'), moment(to).format('YYYY-MM-DD'), stretch.id).then(function (value) {
                // tengo que generar en el rango como si hubiara editado esos días con el valor de precios si he pulsado sobre un día que ya estaba modificaco
                // para así no tener que poner el valor (modo duplicado :) )
                var temp = cloneDeep(value); // copia profunda
                // console.log('useEffect - temp', temp)
                // recojo el/los precio/s del día pulsado que se va a aplicar al rango
                var daySelectedPrices = getPriceFromDatePriceBySelectedday(temp, selectedDay);
                var _loop_1 = function (tempStretchPrice) {
                    var dayPointer = new Date(from);
                    // console.log('dayPointer: ', dayPointer.toString())
                    var endDay = new Date(to);
                    var _loop_2 = function () {
                        var strDay = moment(dayPointer).format('YYYY-MM-DD');
                        // aquí hay dos opciones:
                        // 1. no se ha seleccionadado día de la semana.
                        // 2. se ha seleccionado día o días de la semana
                        var someWeekdaySelected = isSomeWeekdaySelected(weekDaySelected);
                        if (someWeekdaySelected) {
                            // tengo que ignorar los días de la semana que no están seleccionados, esos no se les va a cambiar precio
                            var dayPointerWeekday = dayPointer.getDay();
                            if (!weekDaySelected[dayPointerWeekday]) { // el día de la semana de dayPointer no es de los seleccionados
                                var index = tempStretchPrice.datePrices.findIndex(function (dp) { return dp.date === strDay; });
                                if (index >= 0) {
                                    // elimino ese datePrice de la lista al no estar en los que hay que modificar precio
                                    tempStretchPrice.datePrices.splice(index, 1);
                                }
                                dayPointer.setDate(dayPointer.getDate() + 1); // incremento aquí para evitar en el bucle indefinidamente
                                return "continue";
                            }
                        }
                        // console.log('**************************')
                        // console.log(`trabajando con ${strDay}`)
                        // busco la categoría que estoy recorriendo en la lista de precios que he pulsado
                        var daySelectedPriceToSave = daySelectedPrices.find(function (dsp) { return dsp.passengerCategory.name === tempStretchPrice.passengerCategory.name; });
                        // console.log('daySelectedPriceToSave: ', daySelectedPriceToSave)
                        if (daySelectedPriceToSave) { // en el día que he pulsado está la categoría que estoy recorriendo
                            // console.log('daySelectedPriceToSave')
                            var datePricesDay = tempStretchPrice.datePrices.find(function (dp) { return dp.date === strDay; }); // sólo debe tener uno
                            if (datePricesDay) { // ya tiene precio, lo modifico
                                // console.log('tiene datePricesDay')
                                datePricesDay.price = daySelectedPriceToSave === null || daySelectedPriceToSave === void 0 ? void 0 : daySelectedPriceToSave.price;
                            }
                            else {
                                // console.log('no tiene datePricesDay')
                                var newDatePrice = {
                                    date: strDay,
                                    price: daySelectedPriceToSave.price,
                                    stretchPrice_id: tempStretchPrice.id
                                };
                                // @ts-ignore
                                tempStretchPrice.datePrices.push(newDatePrice);
                            }
                        }
                        dayPointer.setDate(dayPointer.getDate() + 1);
                    };
                    // console.log('endDay: ', endDay.toString())
                    while (dayPointer <= endDay) {
                        _loop_2();
                    }
                };
                // console.log('---------------------')
                // console.log('daySelectedPrices: ', daySelectedPrices)
                // console.log('---------------------')
                // a cada item (cada categoría) de temp en datePrices tengo que añadir o modificar  si ya está el precio para el rango de días seleccionado
                for (var _i = 0, temp_1 = temp; _i < temp_1.length; _i++) {
                    var tempStretchPrice = temp_1[_i];
                    _loop_1(tempStretchPrice);
                }
                // console.log('temp: ', temp)
                setPrices(temp);
                setOriginalPrices(value);
            });
        }
        else {
            props.store.datePricesStore.readDate(moment(selectedDay).format('YYYY-MM-DD'), stretch.id).then(function (value) {
                setPrices(value);
                setOriginalPrices(value);
            });
        }
    }, [selectedDay]);
    if (!selectedDay)
        return null;
    // console.log('render ModalConfigPrice: ')
    var strDate = moment(selectedDay).format('DD/MM/YYYY');
    if (from && to) {
        strDate = "".concat(moment(from).format('DD/MM/YYYY'), " - ").concat(moment(to).format('DD/MM/YYYY'));
    }
    var strWeekDays = '';
    if (from && to) {
        for (var key in weekDaySelected) {
            if (weekDaySelected[key]) {
                strWeekDays += ' ' + T(InvertWeekDays[key]);
            }
        }
    }
    var handleChangePrice = function (name, value, column) {
        // console.log('===============================')
        // console.log('name: ', name)
        // console.log('value: ', value)
        // console.log('===============================')
        var _a;
        if (from && !to) {
            alert(T('isInRangeNoPosibleEdit'));
        }
        var index = prices.findIndex(function (price) {
            return price.passengerCategory.name === name;
        });
        // compruebo que tiene precio general puesto a esa categoría
        if (index < 0) {
            props.store.UI.newError('no se puede poner precio para ' + name + ' ya que no tiene precio general');
            return;
        }
        // creo una copia del array de precios
        var copyPrices = __spreadArray([], prices.map(function (price) { return (__assign({}, price)); }), true);
        var result = copyPrices[index];
        // hay que ver qué caso de uso tenemos.
        // 1. rango con o sin día de la semana seleccionado
        // 2. día concreto
        var isRange = false;
        // si no hay rango
        if (from && to) {
            isRange = true;
        }
        if (!isRange) {
            if (((_a = result.datePrices) === null || _a === void 0 ? void 0 : _a.length) > 0) { // tiene precio puesto
                // creo copia de datePrices
                result.datePrices = __spreadArray([], result.datePrices, true);
                result.datePrices[0] = __assign(__assign({}, result.datePrices[0]), { price: Number(value) });
            }
            else { // no tenía precio
                var temp = {
                    date: moment(selectedDay).format('YYYY-MM-DD'),
                    price: value,
                    stretchPrice_id: result.id
                };
                // @ts-ignore
                result.datePrices = [temp];
            }
            copyPrices[index] = result;
            setPrices(copyPrices);
        }
        else {
            // console.log('handleChangePrice - entrando por rango')
            // ya están los días inicializados que corresponden, sólo hay que recorrerlo y si la categoría corresponde cambiar el precio
            for (var _i = 0, copyPrices_1 = copyPrices; _i < copyPrices_1.length; _i++) {
                var copyPrice = copyPrices_1[_i];
                // console.log('handleChangePrice - for - copyPrice.passengerCategor.name: ', copyPrice.passengerCategory.name)
                if (copyPrice.passengerCategory.name === name) {
                    // console.log('cambiando precio a: ', copyPrice.passengerCategory.name)
                    copyPrice.datePrices = copyPrice.datePrices.map(function (dp) {
                        dp.price = Number(value);
                        // console.log('dp: ', dp)
                        return dp;
                    });
                }
            }
            // console.log('copyPrices antes de setPrices: ', copyPrices)
            setPrices(copyPrices);
        }
    };
    var textButtonSave = T('save...');
    if (from && to) {
        if (isSomeWeekdaySelected(weekDaySelected)) {
            textButtonSave = T('saveRangeWeekdays');
        }
        else {
            textButtonSave = T('saveRange');
        }
    }
    var generatePriceFields = function () {
        if (from && to && selectedDay) {
            // tod_o el rango va a tener el mismo precio en cada categoría
            // tomo el primer día que haya en la prirera categoría y primer datePrice
            if (!prices || prices.length === 0)
                return [];
            // console.log('setPriceFields - prices: ', prices)
            if (!prices[0].datePrices || prices[0].datePrices.length === 0) {
                // Si la primera categoría no tiene precios definidos en el rango (o en el día de inicio),
                // no se puede obtener una fecha para generar los fields.
                // opto por devolver un array vacío, devolver un array vacío es más seguro si todos los campos se inician vacíos.
                return getPriceFields(prices, passengerCategories, selectedDay);
            }
            var strPriceDate = prices[0].datePrices[0].date;
            var date = new Date(strPriceDate);
            // console.log('date: ', date)
            return getPriceFields(prices, passengerCategories, date);
        }
        // no hay rango seleccionado
        return getPriceFields(prices, passengerCategories, selectedDay);
    };
    var handleDeleteField = function (field) {
        console.log('field: ', field);
        console.log('prices: ', prices);
        // busco el price
        var copyPrices = cloneDeep(prices);
        var price = copyPrices.find(function (p) { return p.passengerCategory_id === field.id; });
        console.log('price: ', price);
        if (price && price.datePrices.length > 0) {
            price.datePrices.forEach(function (dp) {
                dp.price = -1;
            });
        }
        setPrices(copyPrices);
    };
    var handleSave = function () {
        if (busy)
            return;
        var toSave = getModifiedPrices(originalPrices, prices);
        if (toSave.length === 0) {
            // console.log('nada cambiado')
            store.UI.newWarning(T('nothingModified'));
            return;
        }
        // return
        onSavePriceClick(toSave);
    };
    return (React.createElement(Modal, { isOpen: modalVisible, toggle: onCancelClick, size: "lg" },
        React.createElement(ModalHeader, { toggle: onCancelClick },
            React.createElement("span", null,
                " ",
                stretch.name,
                " "),
            React.createElement("span", null,
                " ",
                React.createElement("p", null, strDate),
                " "),
            strWeekDays && React.createElement("span", null,
                " ",
                React.createElement("p", null, strWeekDays),
                " ")),
        React.createElement(ModalBody, null,
            !from && React.createElement(Button, { onClick: function () { return onFromClick(selectedDay); } }, T('from')),
            from && !to && React.createElement(Button, { onClick: function () { return onToClick(selectedDay); } }, T('to')),
            from && React.createElement(Button, { onClick: onClearClick }, T('clearRange')),
            React.createElement(Calculator, { taxValue: stretch.tax }),
            React.createElement(PricesView, { isPriceCalendar: true, label: "".concat(T('pricesWithoutTax'), " en ").concat(money.alphabeticCode), priceFields: generatePriceFields(), pricesValues: prices, onChange: handleChangePrice, onDeleteClick: handleDeleteField })),
        React.createElement(ModalFooter, null,
            React.createElement(Button, { color: "secondary", onClick: onCancelClick }, "Cancelar"),
            React.createElement(Button, { color: "primary", onClick: handleSave }, textButtonSave))));
});
// usado para fields en PricesView
var getPriceFromDatePriceBySelectedday = function (stretchPrices, selectedDay) {
    var datePriceResult = [];
    // busco el día seleccionado
    for (var _i = 0, stretchPrices_1 = stretchPrices; _i < stretchPrices_1.length; _i++) {
        var stretchPrice = stretchPrices_1[_i];
        var datePrice = stretchPrice.datePrices.find(function (dt) { return dt.date === moment(selectedDay).format('YYYY-MM-DD'); });
        var toPush = void 0;
        if (datePrice) {
            toPush = __assign(__assign({}, datePrice), { passengerCategory: stretchPrice.passengerCategory });
        }
        else { // el día que he pulsado no tiene precio
            toPush = {
                passengerCategory: stretchPrice.passengerCategory,
                stretchPrice_id: stretchPrice.id,
                date: moment(selectedDay).format('YYYY-MM-DD'),
                price: null
            };
        }
        datePriceResult.push(toPush);
    }
    return datePriceResult;
};
/**
 * Genera fields para price teniendo en cuenta si ya tiene valor
 */
var getPriceFields = function (stretchPrices, passengerCategories, selectedDay) {
    // console.log('getPriceFields - stretchPrices: ', stretchPrices)
    return stretchPrices.filter(function (sp) { return !sp.passengerCategory.disabled_at; }).map(function (stretchPrice) {
        var datePrice = stretchPrice.datePrices.find(function (dt) { return dt.date === moment(selectedDay).format('YYYY-MM-DD'); });
        return {
            name: stretchPrice.passengerCategory.name,
            type: FieldType.Text,
            rules: rules().number(),
            size: 2,
            id: stretchPrice.passengerCategory.id,
            value: datePrice ? datePrice.price : ''
        };
    });
};
/**
 * Compara dos arrays de precios y genera un objeto con los datos modificados, para así evitar enviar los no modificados
 */
var getModifiedPrices = function (originalPrices, modifiedPrices) {
    // verifico que ambos sean arrays
    if (!Array.isArray(originalPrices) || !Array.isArray(modifiedPrices)) {
        throw new Error('Ambos parámetros deben ser arrays');
    }
    // Array para almacenar los cambios
    var changes = [];
    // console.log('originalPrices: ', originalPrices)
    // console.log('modifiedPrices: ', modifiedPrices)
    // itero sobre los precios modificados
    modifiedPrices.forEach(function (modifiedItem) {
        // detecto elementos nuevos cuando no tienen stretchPrice_id en sus datePrices
        var isNewItem = modifiedItem.datePrices &&
            modifiedItem.datePrices.length > 0 &&
            !modifiedItem.datePrices[0].stretchPrice_id;
        if (isNewItem) {
            // console.log('1 if - modifiedItem: ', modifiedItem)
            changes.push(__assign(__assign({}, modifiedItem), { _changeType: 'added' }));
            return;
        }
        // para items existentes, busco el ítem correspondiente en el array original
        var originalItem = originalPrices.find(function (origItem) { return origItem.id === modifiedItem.id; });
        if (!originalItem) {
            // console.log('2 if - modifiedItem: ', modifiedItem)
            changes.push(__assign(__assign({}, modifiedItem), { _changeType: 'added' }));
            return;
        }
        // verifico si hay cambios en los datePrices
        if (modifiedItem.datePrices && modifiedItem.datePrices.length > 0) {
            var changedDatePrices_1 = [];
            modifiedItem.datePrices.forEach(function (modifiedDatePrice) {
                // si el precio no tiene id, es nuevo
                if (!modifiedDatePrice.id && modifiedDatePrice.price && modifiedDatePrice.price >= 0) {
                    // console.log('3 if - modifiedDatePrice: ', modifiedDatePrice)
                    changedDatePrices_1.push(__assign(__assign({}, modifiedDatePrice), { _changeType: 'added' }));
                    return;
                }
                var originalDatePrice = originalItem.datePrices && originalItem.datePrices.length > 0
                    ? originalItem.datePrices.find(function (dp) { return dp.id === modifiedDatePrice.id; })
                    : null;
                // si no existe el stretchPriceDate original o hay cambio en el precio
                if ((!originalDatePrice || originalDatePrice.price !== modifiedDatePrice.price) && modifiedDatePrice.price) {
                    var toPush = {
                        id: modifiedDatePrice.id,
                        stretchPrice_id: modifiedDatePrice.stretchPrice_id,
                        date: modifiedDatePrice.date,
                        price: modifiedDatePrice.price,
                        description: modifiedDatePrice.description,
                        _originalPrice: originalDatePrice ? originalDatePrice.price : null,
                    };
                    if (!originalDatePrice) { // nuevo
                        if (modifiedDatePrice.price >= 0) { // con precio con valor para almacenar (mayor o igual a 0)
                            changedDatePrices_1.push(__assign(__assign({}, toPush), { _changeType: 'added' }));
                        }
                    }
                    else if (originalDatePrice.price !== modifiedDatePrice.price) { // modificado
                        if (modifiedDatePrice.price < 0) {
                            // console.log('!originalDatePrice || originalDatePrice.price !== modifiedDatePrice.price - modifiedDatePrice: ', modifiedDatePrice)
                            changedDatePrices_1.push(__assign(__assign({}, toPush), { _changeType: 'deleted' }));
                        }
                        else {
                            changedDatePrices_1.push(__assign(__assign({}, toPush), { _changeType: 'modified' }));
                        }
                    }
                }
            });
            // si hay datePrices modificados, añado el ítem a los cambios
            if (changedDatePrices_1.length > 0) {
                // console.log('changedDatePrices.length > 0')
                changes.push({
                    id: modifiedItem.id,
                    stretch_id: modifiedItem.stretch_id,
                    passengerCategory_id: modifiedItem.passengerCategory_id,
                    datePrices: changedDatePrices_1,
                    passengerCategory: {
                        id: modifiedItem.passengerCategory.id,
                        name: modifiedItem.passengerCategory.name
                    },
                });
            }
        }
    });
    // busco elementos eliminados (que están en original pero no en modified, no estoy seguro que se dé)
    originalPrices.forEach(function (originalItem) {
        var exists = modifiedPrices.some(function (modItem) { return modItem.id === originalItem.id; });
        if (!exists) {
            changes.push({
                id: originalItem.id,
                _changeType: 'deleted'
            });
        }
    });
    // console.log('getModifiedPrices', changes)
    return changes;
};
export default ModalConfigPrice;



//////////////////
// WEBPACK FOOTER
// ./src/components/PriceCalendar/ModalConfigPrice.tsx
// module id = 1532
// module chunks = 0